import { render, staticRenderFns } from "./metadataAdd.vue?vue&type=template&id=0ced23c0&scoped=true&"
import script from "./metadataAdd.vue?vue&type=script&lang=js&"
export * from "./metadataAdd.vue?vue&type=script&lang=js&"
import style0 from "./metadataAdd.vue?vue&type=style&index=0&id=0ced23c0&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced23c0",
  null
  
)

export default component.exports